import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  Row, Col,
} from 'reactstrap';

export const BasicInfoSkeleton = () => (
  <>
    <Row className="mb-2">
      <Col md={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
      <Col md={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
  </>
);

export const ContactInfoSkeleton = () => (
  <>
    <Row className="mb-2">
      <Col>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
  </>
);

export const AddressInfoSkeleton = () => (

  <>
    <Row className="mb-2">
      <Col>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
    <Row className="mb-2">
      <Col>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Col md={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
      <Col md={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
        />
      </Col>
    </Row>
  </>
);
